// extracted by mini-css-extract-plugin
export default {"pdf-page-canvas":"Dicas_pdf-page-canvas__eKM9q","pdf-loading":"Dicas_pdf-loading__Z6JKU","pdf-controls":"Dicas_pdf-controls__tT5KY"};